export default __webpack_public_path__ + "static/media/plus.4c349eef.svg";